import { Injectable } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private navigationEvents$: Observable<any>;
  private navigationStartSubject = new Subject<NavigationStart>();
  constructor(private router: Router) {
    this.navigationEvents$ = this.router.events.pipe(
      filter((event) => event instanceof NavigationStart || event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError)
    ) as Observable<any>;

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.navigationStartSubject.next(event);
      }
    });
  }

  getNavigationEvents(): Observable<any> {
    return this.navigationEvents$;
  }

  onNavigationStart(): Observable<NavigationStart> {
    return this.navigationStartSubject.asObservable();
  }

}
